(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('UploadDialogController', UploadDialogController);

    UploadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Upload', 'Agenzia', 'Campagna'];

    function UploadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Upload, Agenzia, Campagna) {
        var vm = this;

        vm.upload = entity;
        vm.clear = clear;
        vm.save = save;
        vm.agenzias = Agenzia.query();
        vm.campagnas = Campagna.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.upload.id !== null) {
                Upload.update(vm.upload, onSaveSuccess, onSaveError);
            } else {
                Upload.save(vm.upload, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:uploadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
